import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Popup from "reactjs-popup";
import DatePicker from "react-datepicker";
import PageSectionMenu from './PageSectionMenu';
import { SectionTitle } from './ClassicSectionCard';
import ArtistPickerField from '../../shared/components/ArtistPickerField';

const parseDateTime = (dateTime) => {
  if (dateTime){
    if (typeof(dateTime) === "string") {
      var dateObj = new Date(dateTime);
      return dateObj;
    } else {
      return dateTime;
    }
  }
}

const popupContentStyle = {
  "background": "var(--sl-bg-primary)",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "190px",
  "padding": "0px",
  "zIndex": "1999"
}

const deleteModalContentStyle = {
  "background": "var(--sl-bg-primary)",
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "500px",
  "padding": "15px"
}

const canCreatePerformer = (performer) => {
  return (
    performer
      && performer.artist
      && performer.artist.value
  );
}

const canAddPerformer = (performers) => {
  return !performers.some((performer) => {
    return performer.id === undefined;
  });
}

const ManageLineup = ({
  performers,
  deletePerformer,
  csrfToken,
  team,
  stagePerformerForUpdate,
  updatePerformer,
  updatePerformerActType,
  performerStartTimeChanged,
  performerEndTimeChanged,
  addNewPerformer,
  setArtistOnNewPerformer,
  createPerformer,
  confirm,
  cancelAddPerformer,
  originalPerformer,
  cancelEditPerformer,
  currentUser,
  confirmPageSection,
  fetchPermissionSet,
  updateConfirmPageSection
}) => {
  return (
    <div>
      <div className="card-body">
        <div className="row pb-3">
          <div className="col">
            <SectionTitle title="Lineup"
                          count={performers.length}
                          locked={Boolean(confirmPageSection.permission_set_id)} />
          </div>
          <div className="col-xs-auto" style={{"paddingRight": "15px"}}>
            <PageSectionMenu csrfToken={csrfToken}
                             team={team}
                             confirm={confirm}
                             currentUser={currentUser}
                             confirmPageSection={confirmPageSection}
                             fetchPermissionSet={fetchPermissionSet}
                             updateConfirmPageSection={updateConfirmPageSection} />
          </div>
        </div>
        {performers.length === 0 ? (
          <div className="card no-border mb-0" style={{'background': 'var(--od-c-f3f9fc, #f4f9fc)'}}>
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4 order-md-2 text-left text-md-center">
                  <i className="fal fa-microphone-alt"
                     style={{"fontSize": "120px", "color": "rgba(25, 130, 196, .5)"}}></i>
                </div>
                <div className="col-12 col-md-6 col-lg-8 order-md-1">
                  <h5>Add an Artist</h5>
                  <p className="text-muted">
                    Add an artist to your event, create an offer, and build the show schedule.
                  </p>
                  {currentUser.can_manage_performers ? (
                    <a href="#"
                       onClick={
                         (e) => {
                           e.preventDefault();
                           addNewPerformer();
                         }
                       }
                       className="btn btn-primary">
                      <strong>Add Artist</strong>
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      {performers.length > 0 ? (
        <div className="table-responsive responsive-card-table-wrapper">
        <table className="table table-borderless vertical-middle table-sm responsive-card-table lineup-table" style={{tableLayout: "fixed"}}>
          <colgroup>
            <col span={1} style={{"width": "60%"}} />
            <col span={1} style={{"width": "20%"}} />
            <col span={1} style={{"width": "20%"}} />
          </colgroup>
          <thead>
            <tr>
              <th style={{'paddingBottom': '5px', 'paddingLeft': '24px'}}>Artist</th>
              <th style={{'paddingBottom': '5px'}}>Type</th>
              <th style={{'paddingBottom': '5px', 'paddingRight': '24px'}}>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {performers.sort((a, b) => a.position - b.position).map((performer, index) => (
              !performer.id ? (
                <tr key={index} style={{"background": "var(--od-c-f3f9fc, #f4f9fc)"}}>
                  <td data-label="Artist" style={{'paddingLeft': '24px'}} >
                    <ArtistPickerField id={"new-performer-artist-" + index}
                                       value={performer.artist}
                                       placeholder={"Search Artists"}
                                       teamId={team.id}
                                       onSelect={
                                         ({ artistId, artist }) => {
                                           setArtistOnNewPerformer(index, {
                                             value: artistId,
                                             label: artist.name,
                                             permalink: artist.permalink
                                           });
                                         }
                                       } />
                  </td>
                  <td data-label="Act Type">
                    <select className="custom-select custom-select-sm"
                            onChange={
                              (e) => {
                                updatePerformerActType(index, e.target.value);
                              }
                            }
                            value={performer.act_type || ""}>
                      <option value="headline">Headliner</option>
                      <option value="support">Support</option>
                    </select>
                  </td>
                  <td data-label="Actions" style={{'paddingRight': '24px'}} className="text-right" >
                    <a href='#'
                       onClick={
                         (e) => {
                           e.preventDefault();
                           cancelAddPerformer();
                         }
                       }>
                      Cancel
                    </a>
                    <a href='#'
                       onClick={
                         (e) => {
                           e.preventDefault();

                           if(canCreatePerformer(performer)){
                             createPerformer(csrfToken, team, confirm, performer, index);
                           }
                         }
                       }
                       style={{'borderRadius': '8px'}}
                       className={"btn btn-primary btn-sm ml-2 " + (!canCreatePerformer(performer) ? "disabled" : "")}>
                      Save
                    </a>
                  </td>
                </tr>
              ) : performer.stagedForUpdate ? (
                <tr key={index} style={{"background": "var(--od-c-f3f9fc, #f4f9fc)"}}>
                  <td data-label="Artist" className="overflow-ellipsis" style={{'paddingLeft': '24px'}} >
                    <img src={performer.artistable.image_thumb_url_for_json}
                         className="img-fluid rounded mr-2"
                         style={{"height": "45px", "width": "45px"}} />
                    <strong title={performer.artistable.name}>
                      <a className="text-dark" href={"/artists/" + performer.artistable.permalink}>
                        {performer.artistable.name}
                      </a>
                    </strong>
                  </td>
                  <td data-label="Act Type">
                    <select className="custom-select custom-select-sm"
                            onChange={
                              (e) => {
                                updatePerformerActType(index, e.target.value);
                              }
                            }
                            value={performer.act_type || ""}>
                      <option value="headline">Headliner</option>
                      <option value="support">Support</option>
                    </select>
                  </td>
                  <td data-label="Actions" style={{'paddingRight': '24px'}} className="text-right" >
                    <a href='#'
                       onClick={
                         (e) => {
                           e.preventDefault();
                           cancelEditPerformer(performer, originalPerformer);
                         }
                       }>
                      Cancel
                    </a>
                    <a href='#'
                       onClick={
                         (e) => {
                           e.preventDefault();
                           updatePerformer(csrfToken, team, performer);
                         }
                       }
                       style={{'borderRadius': '8px'}}
                       className="btn btn-primary btn-sm ml-2">
                      Save
                    </a>
                  </td>
                </tr>
              ) : (
                <tr key={index}>
                  <td className="overflow-ellipsis lineup-artist-cell" data-label="Artist" style={{'paddingLeft': '24px'}} >
                    <img src={performer.artistable.image_thumb_url_for_json}
                         className="img-fluid rounded mr-2 lineup-artist-image"
                         style={{"height": "45px", "width": "45px"}} />
                    <strong title={performer.artistable.name}>
                      <a className="text-dark" href={"/artists/" + performer.artistable.permalink}>
                        {performer.artistable.name}
                      </a>
                    </strong>
                  </td>
                  <td className="lineup-type-cell" data-label="Act Type">
                    {performer.act_type ? (
                      performer.humanized_act_type
                    ) : (
                      <span className="text-muted">
                        {performer.humanized_act_type}
                      </span>
                    )}
                  </td>
                  <td data-label="Actions" style={{'paddingRight': '24px'}} className="text-right" >
                    {currentUser.can_manage_performers ? (
                      <>
                        {/* Mobile: Direct action icons */}
                        <div className="d-flex d-md-none gap-3 lineup-mobile-actions">
                          <a href="#"
                             onClick={
                               (e) => {
                                 e.preventDefault();
                                 stagePerformerForUpdate(performer);
                               }
                             }
                             className="text-muted">
                            <i className="fas fa-pencil"></i>
                          </a>
                          <Popup
                              trigger={
                                <a href="#"
                                   className="text-muted">
                                  <i className="fas fa-trash"></i>
                                </a>
                              }
                              modal
                              contentStyle={deleteModalContentStyle}
                              closeOnDocumentClick
                            >
                            {closeDeleteModal => (
                              <div>
                                <div className="row">
                                  <div className="col">
                                    <div className="row">
                                      <div className="col">
                                        <h5 style={{"marginBottom": "16px"}}>
                                          <strong>Delete artist?</strong>
                                        </h5>
                                      </div>
                                      <div className="col-xs-auto">
                                        <a href="#"
                                           className="text-dark"
                                           style={{"paddingRight": "15px"}}
                                           onClick={
                                             (e) => {
                                               e.preventDefault();
                                               closeDeleteModal();
                                             }
                                           } >
                                          <i className="fa fa-times"></i>
                                        </a>
                                      </div>
                                    </div>
                                    <p>Are you sure you want to remove this artist?</p>
                                    <div className="text-right">
                                      <a href="#"
                                         onClick={
                                           (e) => {
                                             e.preventDefault();
                                             closeDeleteModal();
                                           }
                                         }>
                                        Cancel
                                      </a>
                                      <a href="#"
                                         className="btn btn-danger ml-3"
                                         onClick={
                                           (e) => {
                                             e.preventDefault();
                                             closeDeleteModal();
                                             deletePerformer(csrfToken, team, performer);
                                           }
                                         }>
                                        Remove
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Popup>
                        </div>
                        {/* Desktop: Overflow menu */}
                        <div className="d-none d-md-inline-block">
                          <Popup arrow={false}
                                 offsetY={5}
                                 position="bottom right"
                                 contentStyle={popupContentStyle}
                                 onOpen={
                                   (e) => {
                                     e.preventDefault();
                                   }
                                 }
                                 trigger={open => (
                                   <a href="#"
                                      className="btn btn-external btn-sm note-card-inline-menu">
                                     <i className="far fa-ellipsis-v"></i>
                                   </a>
                                 )} >
                            {close => (
                              <div className='row text-left'>
                                <div className="col-12">
                                  <ul className="list-group offer-inline-menu">
                                    <li className="list-group-item">
                                      <a href="#"
                                         onClick={
                                           (e) => {
                                             e.preventDefault();
                                             close();
                                             stagePerformerForUpdate(performer);
                                           }
                                         }
                                         className="text-muted">
                                        <span className="d-inline-block text-center" style={{width: "28px"}}>
                                          <i className="fas fa-pencil"></i>
                                        </span>
                                        <span className="text-dark">
                                          Edit Artist
                                        </span>
                                      </a>
                                    </li>
                                    <li className="list-group-item delete-offer-li">
                                      <Popup
                                          trigger={
                                            <a href="#"
                                               className="text-danger">
                                              <span className="d-inline-block text-center" style={{width: "28px"}}>
                                                <i className="fas fa-trash"></i>
                                              </span>
                                              Delete
                                            </a>
                                          }
                                          modal
                                          contentStyle={deleteModalContentStyle}
                                          closeOnDocumentClick
                                        >
                                        {closeDeleteModal => (
                                          <div>
                                            <div className="row">
                                              <div className="col">
                                                <div className="row">
                                                  <div className="col">
                                                    <h5 style={{"marginBottom": "16px"}}>
                                                      <strong>Delete artist?</strong>
                                                    </h5>
                                                  </div>
                                                  <div className="col-xs-auto">
                                                    <a href="#"
                                                       className="text-dark"
                                                       style={{"paddingRight": "15px"}}
                                                       onClick={
                                                         (e) => {
                                                           e.preventDefault();

                                                           close();
                                                           closeDeleteModal();
                                                         }
                                                       } >
                                                      <i className="fa fa-times"></i>
                                                    </a>
                                                  </div>
                                                </div>
                                                <p>Are you sure you want to remove this artist?</p>
                                                <div className="text-right">
                                                  <a href="#"
                                                     onClick={
                                                       (e) => {
                                                         e.preventDefault();
                                                         close();
                                                         closeDeleteModal();
                                                       }
                                                     }>
                                                    Cancel
                                                  </a>
                                                  <a href="#"
                                                     className="btn btn-danger ml-3"
                                                     onClick={
                                                       (e) => {
                                                         e.preventDefault();
                                                         close();
                                                         closeDeleteModal();
                                                         deletePerformer(csrfToken, team, performer);
                                                       }
                                                     }>
                                                    Remove
                                                  </a>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </Popup>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </Popup>
                        </div>
                      </>
                    ) : null}
                  </td>
                </tr>
              )
            ))}
          </tbody>
        </table>
        </div>
      ) : null}
      {currentUser.can_manage_performers && performers.length > 0 ? (
        <div className="card-body pt-3">
          <a href="#"
             className={canAddPerformer(performers) ? "" : "disabled"}
             onClick={
               (e) => {
                 e.preventDefault();

                 if(canAddPerformer(performers)){
                   addNewPerformer();
                 }
               }
             }>
            <i className="fas fa-plus-circle"></i>
            &nbsp;
            Add Artist
          </a>
        </div>
      ) : null}
    </div>
  )
};

ManageLineup.propTypes = {
  performers: PropTypes.array,
  deletePerformer: PropTypes.func.isRequired,
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  stagePerformerForUpdate: PropTypes.func.isRequired,
  updatePerformer: PropTypes.func.isRequired,
  updatePerformerActType: PropTypes.func.isRequired,
  performerStartTimeChanged: PropTypes.func.isRequired,
  performerEndTimeChanged: PropTypes.func.isRequired,
  addNewPerformer: PropTypes.func.isRequired,
  setArtistOnNewPerformer: PropTypes.func.isRequired,
  createPerformer: PropTypes.func.isRequired,
  confirm: PropTypes.object.isRequired,
  cancelAddPerformer: PropTypes.func.isRequired,
  originalPerformer: PropTypes.object,
  cancelEditPerformer: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  confirmPageSection: PropTypes.object,
  fetchPermissionSet: PropTypes.func.isRequired,
  updateConfirmPageSection: PropTypes.func.isRequired
};

export default ManageLineup;
